import styles from "./DiagonalDivider2.module.css";
import behaelter from "../assets/Illustration_Individualbe.svg";
import icons from "../assets/Illustration_Produktvariationen.svg";
export default function DiagonalDivider() {
  return (
    <div className={styles.diagonalDivider}>
      <div className={styles.diagonalDividerBg} />

      <div className={styles.content}>
        <div className={styles.left}>
          <img src={behaelter} alt="" />
        </div>

        <div className={styles.right}>
          <img src={icons} alt="" className={styles.imageicons} />
          <div className={styles.greenTagline}>
            <p>
              IHR PROJEKT-PARTNER IN SACHEN STAHL. VON
              INDIVIDUAL&shy;ANFERTIGUNGEN FÜR IHRE PRODUKTIONSANLAGE ÜBER
              GROSSSERIEN FÜR DIE LOGISTIK BIS ZU KÜNSTLERISCHEN EINZELSTÜCKEN:
              WIR GEBEN IHREN VISIONEN EINE FORM.
            </p>
          </div>
        </div>
      </div>

      <div className={styles.buttonContainer}>
        <div className={styles.buttonWrapper}>
          <MyButton />
        </div>
      </div>
    </div>
  );
}
function MyButton() {
  return null; // Ausgeblendet bis Inhalte fertig sind
  /*
  return (
    <a
      className={styles.outlineButton}
      href="/Typo und Farb Informationen.pdf"
      target="_blank"
      rel="noopener noreferrer"
    >
      <span className={styles.outlineButtonLabel}>Produktbeispiele</span>
    </a>
  );
  */
}
